export default "__VITE_ASSET__BcELepSm__"